import { render, staticRenderFns } from "./CoachRecruit.vue?vue&type=template&id=b345e5ca&"
import script from "./CoachRecruit.vue?vue&type=script&lang=js&"
export * from "./CoachRecruit.vue?vue&type=script&lang=js&"
import style0 from "./CoachRecruit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports